import { useAuth } from 'react-oidc-context';
import { useToFetchDosageDiaries } from '../hooks/useToFetchDosageDiaries';
import { DosageDiaryProfileCards } from './DosageDiaryProfileCards';
import { useState } from 'react';
import {
  DosageDiaryListItem,
  DosageDiaryListProps,
} from '../interface/interface';
import { DosageDiaryProfileContent } from './DosageDiaryProfileContent';

export function DosageDiaryList({ fetchDosageDiary }: DosageDiaryListProps) {
  const { user } = useAuth();
  const [profiles] = useToFetchDosageDiaries(
    user!.access_token,
    fetchDosageDiary,
  );
  const [assignmentModal, setAssignModalVisibility] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState<DosageDiaryListItem>();

  if (!profiles?.length) {
    return <p className="font-semibold text-center">No profiles to display</p>;
  }

  return (
    <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-3 lg:gap-8">
      <div className="grid grid-cols-1 gap-4">
        <section aria-labelledby="list" className="h-full">
          <div
            className="overflow-hidden rounded-lg bg-white shadow overflow-y-auto max-h-[720px] [&::-webkit-scrollbar]:w-2
  [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300"
          >
            <div className="p-6">
              <DosageDiaryProfileCards
                profiles={profiles}
                dosageDiarySelector={(profile) => {
                  setSelectedProfile(profile);
                }}
              />
            </div>
          </div>
        </section>
      </div>
      <div className="grid grid-cols-1 gap-4 lg:col-span-2">
        {selectedProfile ? (
          <DosageDiaryProfileContent
            token={user!.access_token}
            profile={selectedProfile}
            modalVisibility={assignmentModal}
            setModalvisibility={(val) => setAssignModalVisibility(val)}
          />
        ) : null}
      </div>
    </div>
  );
}
